import React from "react";
import "./style.scss";

const Buttons = ({ companyData }) => {
  const yandexMapsUrl = `https://yandex.com/maps/?ll=${companyData?.longitude},${companyData?.latitude}&z=15&pt=${companyData?.longitude},${companyData?.latitude},pm2rdl`;

  return (
    <div className="buttons">
      {companyData?.longitude && companyData?.latitude && (
        <a
          href={yandexMapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="button"
        >
          Bizning manzil
        </a>
      )}
      {companyData?.employee_phone && (
        <a
          href={`tel:+${companyData?.employee_phone}`}
          target="_blank"
          rel="noopener noreferrer"
          className="button"
        >
          Bizga qo'ng'iroq qiling
          <span className={`icon }`} />
        </a>
      )}
      {companyData?.instagram && (
        <a
          href={companyData?.instagram}
          target="_blank"
          rel="noopener noreferrer"
          className="button"
        >
          Instagram
          <span className={`icon }`} />
        </a>
      )}
      {companyData?.facebook && (
        <a
          href={companyData?.facebook}
          target="_blank"
          rel="noopener noreferrer"
          className="button"
        >
          Facebook
          <span className={`icon }`} />
        </a>
      )}
      {companyData?.telegram && (
        <a
          href={companyData?.telegram}
          target="_blank"
          rel="noopener noreferrer"
          className="button"
        >
          Telegram
          <span className={`icon }`} />
        </a>
      )}
      {companyData?.telegram_bot && (
        <a
          href={companyData?.telegram_bot}
          target="_blank"
          rel="noopener noreferrer"
          className="button"
        >
          Telegram Bot
          <span className={`icon }`} />
        </a>
      )}
      {companyData?.telegram_channel && (
        <a
          href={companyData?.telegram_channel}
          target="_blank"
          rel="noopener noreferrer"
          className="button"
        >
          Telegram Channel
          <span className={`icon }`} />
        </a>
      )}
    </div>
  );
};

export default Buttons;
